import React, { Component } from "react";

export default class ImageRugs extends Component {
  render() {
    return (
      <img
        id="selected_rug"
        style={{ width: "100%", height: "100%" }}
        src={this.props.image}
        alt="rug-img"
      />
    );
  }
}
